var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-layout md-gutter md-alignment-top-center" },
    [
      _c("TextField", {
        attrs: { label: "冷蔵庫ID", type: "number" },
        on: { keyup: _vm.keyup, click: _vm.searchBox },
        model: {
          value: _vm.boxId,
          callback: function($$v) {
            _vm.boxId = $$v
          },
          expression: "boxId"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03a9a7af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a9a7af","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/SelectBox.vue
// module id = null
// module chunks = 